export class SubmitReorder {
  static readonly type = '[Wizard Submission] Submit Reorder';
  constructor(public userWillPayLater: boolean) {}
}

export class MakePayment {
  static readonly type = '[Wizard Submission] Make Payment';
}

export class CreateToDo {
  static readonly type = '[Wizard Submission] Create ToDo';
}

export class SetCollectionStatusIfNeeded {
  static readonly type = '[Wizard Submission] Set Collection Status';
  constructor(public isPaymentMade: boolean) {}
}

export class ResetOrderWizardSubmission {
  static readonly type = '[Wizard Submission] Reset order wizard submission';
}
